import { PUT_REDUX_QUOTE_LIST } from '../../reducers/constants';

const putReduxAllQuotes = (allQuotes) => ({
  type: PUT_REDUX_QUOTE_LIST,
  allQuotes,
});
export default putReduxAllQuotes;
